import React from "react";
import { Row, Col, Form } from "antd";
import { PriceFormInput } from "components/ratecard/_common";
import { timeOptions } from "./contstants";
import { StyledCustomSelect, StyledOption } from "components/ratecard/_common/styles";

interface Props {
  name: string[];
  currency: string;
}

const EditInline: React.FC<Props> = ({ name, currency }) => {
  return (
    <Row gutter={30}>
      <Col>
        <PriceFormInput label="Amount" name={name.concat(["price"])}>
          <PriceFormInput.PriceInput />
        </PriceFormInput>
      </Col>
      <Col style={{ display: "flex", alignItems: "flex-end" }}>
        <PriceFormInput label="Currency">{currency}</PriceFormInput>
      </Col>
      <Col style={{ display: "flex", alignItems: "flex-end" }}>
        <Form.Item name={name.concat("type")}>
          <StyledCustomSelect placeholder="Hour">
            {timeOptions.map((option) => (
              <StyledOption key={option.id} value={option.id}>
                {option.name}
              </StyledOption>
            ))}
          </StyledCustomSelect>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EditInline;
